<template>
    <div class="wrap-border contract-wrap">
<!--      <h2 class="contract-title">{{details.contractName}}</h2>-->
      <h2 class="contract-title">
        <!-- 原有状态图标和名称 -->
        <img v-if="details.contractStatus == 0" src="../../../static/images/lyzt_l.png" class="status-icon" alt="">
        <img v-else-if="details.contractStatus == 1" src="../../../static/images/lyzt_c.png" class="status-icon" alt="">
        <img v-else-if="details.contractStatus == 2 || details.contractStatus == 3" src="../../../static/images/lyzt_h.png" class="status-icon" alt="">
        <span>{{details.contractName}}</span>

        <!-- 新增：异议申诉 跳转按钮 -->
        <router-link to="/server/representation" class="appeal-btn">
          <img src="../../../static/images/ss.png" alt="异议申诉">
          <span class="btn-text">异议申诉</span>
        </router-link>
      </h2>
      <div class="contract-box">
            <!-- 合同名称 -->
        <a>发包单位：{{details.contractorName}}</a></br>
        <a>承包单位：{{details.contractedName}}</a></br>
        <a>履约状态：
          <span v-if="details.performanceStatus == '1'">收付款完成</span>
          <span v-if="details.performanceStatus == '2'">进度款完成</span>
          <span v-if="details.performanceStatus == '3'">尾款完成</span>
          <span v-if="details.performanceStatus == '4'">纠纷中</span>
          <span v-if="details.performanceStatus == '5'">终止</span>
          <span v-if="details.performanceStatus == '6'">履约中</span>
          <span v-if="details.performanceStatus == '7'">其他</span>
        </a></br>
<!--            <h4>{{details.contractName}}</h4>-->
<!--            <p>一、合同编号：{{details.contractNumber}}</p>-->
<!--            <p>二、合同名称：{{details.contractName}}</p>-->
<!--            <p>三、采购项目编码：{{details.projectCode}}</p>-->
<!--            &lt;!&ndash; 项目名称 &ndash;&gt;-->
<!--            <p>四、采购项目名称：{{details.projectName}}</p>-->
<!--            <p>五、合同主体</br>-->
<!--                <a>发包单位：{{details.contractorName}}</a></br>-->
<!--                <a>发包单位统一社会信用代码：{{details.contractorCreditCode}}</a></br>-->
<!--                <a>联系方式：{{details.contractorContact}}</a></br>-->
<!--                <a>承包单位：{{details.contractedName}}</a></br>-->
<!--                <a>承包单位统一社会信用代码：{{details.contractedCreditCode}}</a></br>-->
<!--                <a>联系方式：{{details.contractedContact}}</a></br>-->
<!--            </p>-->
<!--            <p>六、合同主要信息</br>-->
<!--                <a>合同类型：{{details.contractType}}</a></br>-->
<!--                <a>履约状态：-->
<!--                    <span v-if="details.performanceStatus == '1'">收付款完成</span>-->
<!--                    <span v-if="details.performanceStatus == '2'">进度款完成</span>-->
<!--                    <span v-if="details.performanceStatus == '3'">尾款完成</span>-->
<!--                    <span v-if="details.performanceStatus == '4'">纠纷中</span>-->
<!--                    <span v-if="details.performanceStatus == '5'">终止</span>-->
<!--                </a></br>-->
<!--                <a>合同期限：{{details.contractPeriod}}</a></br>-->
<!--                <a>合同金额：{{details.contractAmount}}</a>-->
<!--            </p>-->
<!--            &lt;!&ndash; 合同内容 &ndash;&gt;-->
<!--            &lt;!&ndash; <div>{{details.contractName}}</div> &ndash;&gt;-->
<!--            <p>七、合同签订日期：{{details.contractSignDate}}</p>-->
<!--            &lt;!&ndash; 备注 &ndash;&gt;-->
<!--            <p>八、其他补充事宜：{{details.remark}}</p>-->
<!--        &lt;!&ndash; <div v-for="item in fileList" class="fileclass" :key="item.id">-->
<!--          <el-link-->
<!--            @click="downLoad(item.name, item.fileId)"-->
<!--            target="_blank"-->
<!--            type="danger"-->
<!--          >-->
<!--            {{ item.name }}-->
<!--          </el-link>-->
<!--        </div> &ndash;&gt;-->
      </div>
    </div>
  </template>
  <script>
  import {
    downLoadFile,
    getContractsDetail,
  } from "@/api";
  import BASE_URL from "@/api/base.js";
  export default {
    components: {},
    data() {
      return {
        details: {},
        // fileList: [],
      };
    },
    created() {},
    mounted() {},
    methods: {
      // downLoad(name, url) {
      //   let data = { fileName: name, url: url };
      //   downLoadFile(data).then((res) => {
      //     if (!res) return;
      //     //创建 blob 对象
      //     const blob = new Blob([res], { type: "application/vnd.ms-excel" });
      //     //创建一个唯一的 URL
      //     const url = URL.createObjectURL(blob);
      //     //下载文件
      //     //创建一个a标签
      //     const a = document.createElement("a");
      //     //将下载地址赋值给herf属性
      //     a.href = url;
      //     //设置下载文件的名字
      //     a.download = name;
      //     a.click();
      //     //读文件  创建 FileReader 对象
      //     const reader = new FileReader();
      //     //文件内容转为 String
      //     reader.readAsText(blob);
      //     //当读取操作成功完成时调用
      //     reader.onload = () => {
      //       this.result = reader.result;
      //     };
      //   });
      // },
      getDetail(id) {
        getContractsDetail({ id }).then((res) => {
            // console.log(res);
            if (Object.keys(res).length) {
              this.$set(
                this,
                "details",
                Object.assign({}, res)
              );
              // this.fileList = JSON.parse(res.matterfile);
            }
        });
      },
    },
    computed: {},
    watch: {
      $route: {
        handler(v) {
          const {
            params: { id },
          } = v;
          this.getDetail(id);
        },
        immediate: true,
        deep: true,
      },
    },
  };
  </script>
  
  <style>
  /* @import "/src/views/quill/quill.core.css";
  @import "/src/views/quill/quill.snow.css";
  @import "/src/views/quill/quill.bubble.scss";
  .ql-container.ql-snow {
    border: none;
  } */
  </style>
  <style lang="scss">
  .contract-wrap {
    width: 100%;
    padding: 15px 25px;
    background: #fff;
    word-wrap: break-word;
    & > .contract-title {
      font-size: 24px;
      font-weight: 700;
      // padding: 0 70px;
      text-align: left;
      border-bottom: 1px solid #bebebe;
      padding:0 0 10px 0;

      /* 新增 Flex 布局，使图片和文字对齐 */
      display: flex;
      align-items: center;

      /* 新增图片的样式控制 */
      .status-icon {
        height: 28px; /* 根据你的实际图片大小调整高度 */
        width: auto;
        margin-right: 12px; /* 图片和文字之间的间距 */
      }
      /* 新增：异议申诉按钮样式 */
      .appeal-btn {
        margin-left: auto; /* 将按钮推至最右侧 */
        display: flex;
        flex-direction: column; /* 让内部图片和文字上下排列 */
        align-items: center; /* 居中对齐 */
        text-decoration: none; /* 去除路由链接默认下划线 */
        cursor: pointer;

        img {
          width: 24px; /* 根据你的 ss.png 实际大小可进行微调 */
          height: 24px;
          margin-bottom: 4px; /* 图标与文字的间距 */
        }

        .btn-text {
          font-size: 14px;
          color: #666; /* 根据你的 UI 需求调整文字颜色 */
          font-weight: 400; /* 重置继承自 h2 的加粗效果 */
          line-height: 1;
        }

        &:hover {
          opacity: 0.8; /* 添加简单的鼠标悬浮反馈 */
        }
      }
    }
    & > .contract-box {
      margin: 15px 0 0;
      line-height: 2;
      font-size: 15px;
      color: #7c7c7c;
      & > p {
        & > a {
          color: #7c7c7c;
        }
    }
    }
    .fileclass {
      margin-top: 10px;
    }
  }
  </style>